import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from '@/common/types/errorResponse';
import { AxiosResponse } from 'axios';
import { EstablishmentUserExternalTokenResponse } from "../../types/users/establishmentUserExternalTokens.type";

interface UseGetEstablishmentUserExternalToken {
  tokenId?: string;
  onSuccess?: (reponse: AxiosResponse<EstablishmentUserExternalTokenResponse>) => void;
  onError?: (error: ErrorResponse) => void;
}

const useGetEstablishmentUserExternalToken = ({ tokenId, onSuccess, onError }: UseGetEstablishmentUserExternalToken) => {
  const privateAxios = usePrivateAxios();

  return useMutation<AxiosResponse<EstablishmentUserExternalTokenResponse>, ErrorResponse>({
    mutationKey: ['getEstablishmentUserExternalToken', tokenId],
    mutationFn: () => privateAxios.get(`/establishment/user_external_tokens/${tokenId}`),
    onSuccess,
    onError,
  });
};

export default useGetEstablishmentUserExternalToken;
